
/**
 * History module for lbbw-am.de
 *
 * @author Florian Gutwald
 * Converted to Plain JS for Rollup
 */
import SectionScroll from './SectionScroll';

/**
 * Initialize the history section with custom section scroll
 */
export function HistoryClass() {
  const bodyElement = document.body;

  if (!bodyElement) {
    console.warn('History: body element not found');
    return;
  }

  // Initialize SectionScroll on body with custom options
  new SectionScroll(bodyElement, {
    // CSS class for bullet navigation
    bulletsClass: 'section-bullets',

    // CSS class for sectioned content
    sectionsClass: 'history-event',

    // scroll duration in ms
    scrollDuration: 500,

    // displays titles on hover
    titles: true,

    // top offset in pixels
    topOffset: 0,

    // easing option
    easing: 'ease-in-out'
  })}
